module.exports = __webpack_public_path__ + "img/model_1.9722f640.png";